import React from "react";

import { styled } from "@mui/material/styles";
import Reveal from "../Animations/Reveal";
import { useHeaderHeightContext } from "../../context/HeaderHeight";

const MUITitle = styled("div")<{ height: number }>(({ theme, height }) => ({
  textAlign: "center",
  padding: "0 12rem",

  "@media screen and (orientation: landscape)": {
    position: "absolute",
    top: "0",
    height,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    ".children": {
      padding: "0 8rem",
      minWidth: "107.7rem",
      height: "50%",
      // backdropFilter: "blur(0.8rem)",
      background: "rgba(35, 35, 35, 0.825)",
      borderRadius: "1rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",

      "& > *": {
        color: theme.palette.background.default,
      },

      "& h1, & h2, & h3, & h4": {
        fontSize: `${height / 8.5}px`,
        // margin: "0",
        // lineHeight: 1.2,
      },

      "& h3, & h4": {
        fontSize: `${height / 11}px`,
        // margin: "0",
        // lineHeight: 1.2,
      },
    },
  },
}));

interface TitleProps {
  children: React.ReactNode;
  className?: string;
  disableAnimation?: boolean;
}

const Title = React.memo<TitleProps>(
  ({ children, className, disableAnimation }) => {
    const { height } = useHeaderHeightContext();

    return (
      <MUITitle className={className} height={height}>
        <Reveal disabled={disableAnimation}>
          <div className="children">{children}</div>
        </Reveal>
      </MUITitle>
    );
  },
);

export default Title;
